import { useState, useEffect } from "react";

import { Modal, Button, Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import ValidateLicenceModel from "./ValidateLicenceModel";
import {
  allLicenceDetails,
  insertLicence,
  updateLicenceDetail,
  verifyLicenseDetails,
} from "@/api/bid";
import { AgentLiecenseErrorMsgs } from "@/setting";

import { useDispatch } from "react-redux";
import { setAllLicenseInfo } from "@/bidFeature/propertyDetailSlice";
import { format } from "crypto-js";
import CitySuggestionInputField from "../user/My Profile/components/CitySuggestionInputField";
function LicenceModal({
  show,
  handleClose,
  handleSubmit,
  addLicenseInfo,
  editData,
  formData,
  isEditing,
  setShowStateLicenseError,
  showStateLicenseError,
  setLicenseCityDropDown,
}) {
  // const [formData, setFormData] = useState(licenceInfo);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  // const [showStateLicenseError,setShowStateLicenseError]=useState("")
  const [cityList, setCityList] = useState([]);

  const [licenceInfo, setLicenceInfo] = useState({
    IssueBy: "",
    state: "",
    LicenseNumber: "",
    ExpiryDate: "",
    AddressLine1: "",
    AddressLine2: "",
    city: "",
    zipcode: "",
    Status: "",
    agentLicenseState: "",
  });

  // console.log("EditData received in modal:", editData);

  const licenceFormHandler = (e) => {
    const { name, value } = e.target;
    if (name === "agentLicenseState") {
      setLicenseCityDropDown(value);
    }
    setLicenceInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationResult = ValidateLicenceModel(licenceInfo);
    setFormErrors((prev) => ({
      ...prev,
      [name]: validationResult.newErrors[name],
    }));
  };
  useEffect(() => {
    setLicenceInfo({
      IssueBy: "",
      LicenseNumber: "",
      state: "",
      ExpiryDate: "",
      AddressLine1: "",
      AddressLine2: "",
      city: "",
      zipcode: "",
      Status: "",
      agentLicenseState: "",
    });
  }, [show]);
  useEffect(() => {
    if (editData) {
      const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        const [month, day, year] = dateString.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      };
      setLicenceInfo({
        IssueBy: editData.affiliatedCompany || "",
        state: editData.state || "",
        LicenseNumber: editData.licenceNumber || "",
        ExpiryDate: formatDateForInput(editData.licenceExpiryDate) || "",
        AddressLine1: editData.address1 || "",
        AddressLine2: editData.address2 || "",
        city: editData.city || "",
        zipcode: editData.zipcode || "",
        Status: editData.status || "",
        agentLicenseState: editData.agentLicenseState || "",
      });
    } else {
      // Reset form when not editing
      setLicenceInfo({
        IssueBy: "",
        state: "",
        LicenseNumber: "",
        ExpiryDate: "",
        AddressLine1: "",
        AddressLine2: "",
        city: "",
        zipcode: "",
        Status: "",
        agentLicenseState: "",
      });
    }
  }, [editData]);

  const handleFormSubmit = async () => {
    // Pass the license info to parent component
    const { isValid, newErrors } = ValidateLicenceModel(licenceInfo);
    if (!isValid) {
      setFormErrors(newErrors);
      return;
    } else {
      setFormErrors({});
      const licNo = licenceInfo.LicenseNumber;
      const stateid = licenceInfo.state;
      const formatDateForApi = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${month}/${day}/${year}`;
      };

      const payload = {
        affiliatedCompany: editData
          ? editData.affiliatedCompany
          : licenceInfo.IssueBy,
        agentLicenseState: editData
          ? editData.agentLicenseState
          : licenceInfo.agentLicenseState,
        cityFromDropDown: false,
        licenceExpiryDate: editData
          ? editData.licenceExpiryDate
          : formatDateForApi(licenceInfo.ExpiryDate),
        licenceNumber: editData
          ? editData.licenceNumber
          : licenceInfo.LicenseNumber,
        primaryAgentLicenceId: editData ? editData.licenceId : undefined,
        stateId: editData ? editData.state : licenceInfo.state,
        agentLicenseAddress1: editData
          ? editData?.address1
          : licenceInfo.AddressLine1,
        agentLicenseAddress2: editData
          ? editData?.address2
          : licenceInfo.AddressLine2,
        agentLicenseCity: editData ? editData?.city : licenceInfo.city,
        agentLicenseZip: editData ? editData?.zip : licenceInfo.zipcode,
      };

      const payloadEdit = {
        affiliatedCompany: licenceInfo.IssueBy,
        agentLicenseState: licenceInfo.agentLicenseState,
        cityFromDropDown: false,
        licenceExpiryDate: formatDateForApi(licenceInfo.ExpiryDate),
        licenceNumber: licenceInfo.LicenseNumber,
        primaryAgentLicenceId: editData ? editData.licenceId : undefined,
        stateId: licenceInfo.state,
        agentLicenseAddress1: licenceInfo.AddressLine1,
        agentLicenseAddress2: licenceInfo.AddressLine2,
        agentLicenseCity: licenceInfo.city,
        agentLicenseZip: licenceInfo.zipcode,
      };

      let response = await verifyLicenseDetails(licNo, stateid);
      if (response?.data?.verificationStatus === "LICENSE_FORMAT_NOT_OK") {
        let agentStateError =
          AgentLiecenseErrorMsgs[response?.data?.jurisdictName];
        if (agentStateError !== "No license format information") {
          setShowStateLicenseError(agentStateError);
        }
      } else {
        handleSubmit(isEditing ? payloadEdit : payload);
        setShowStateLicenseError("");
        // setLicenceInfo({
        //   IssueBy: "",
        //   LicenseNumber: "",
        //   state: "",
        //   ExpiryDate: "",
        //   AddressLine1: "",
        //   AddressLine2: "",
        //   city: "",
        //   zipcode: "",
        //   Status: "",
        //   agentLicenseState: "",
        // });
      }
    }
  };

  const closeModal = () => {
    setFormErrors({});
    handleClose();
    setShowStateLicenseError("");
    setLicenceInfo({
      IssueBy: "",
      LicenseNumber: "",
      state: "",
      ExpiryDate: "",
      AddressLine1: "",
      AddressLine2: "",
      city: "",
      zipcode: "",
      Status: "",
      agentLicenseState: "",
    });
  };
  return (
    <>
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editData ? "Edit License" : "Add License"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {showStateLicenseError?.length > 0 && (
            <p className="text-danger">{showStateLicenseError}</p>
          )}
          <Form>
            <Row>
              {/* //!Show any general form errors uncomment the below line when you want it for only error purpose */}
              {/* {Object.keys(formErrors).length > 0 && (
                <div className="alert alert-danger mt-3">
                  <ul className="mb-0">
                    {Object.values(formErrors).map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </div>
              )} */}
              {addLicenseInfo?.map((field, index) => (
                <>
                  <Form.Group
                    as={Col}
                    md="6"
                    key={index}
                    controlId={`lform${field.label.replace(/\s+/g, "")}`}
                    className="mb-3"
                  >
                    <Form.Label className="form-label pp-form-label fs-12">
                      {field.label}
                    </Form.Label>
                    {field?.required && <span className="text-danger">*</span>}
                    {field.type === "select" ? (
                      <>
                        <Form.Select
                          name={field.formValueLabel}
                          className={`${
                            formErrors[field.formValueLabel]
                              ? "error-border"
                              : ""
                          } form-control pp-input-field pp-form-label form-field-style`}
                          onChange={licenceFormHandler}
                          value={licenceInfo[field?.formValueLabel]}
                          onBlur={handleBlur}
                        >
                          {/* {console.log("field", field.options)} */}
                          <option value="" className="pp-form-label">
                            Select
                          </option>
                          {field?.options?.map((option, i) => (
                            <option key={i} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    ) : field.type === "date" ? (
                      <>
                        <Form.Control
                          type="date"
                          // placeholder={field.placeholder}
                          className={`${
                            formErrors[field.formValueLabel]
                              ? "error-border"
                              : ""
                          } form-control pp-input-field pp-form-label form-field-style`}
                          value={
                            licenceInfo[field?.formValueLabel]
                              ? new Date(licenceInfo[field.formValueLabel])
                                  .toISOString()
                                  .split("T")[0]
                              : ""
                          }
                          name={field.formValueLabel} // Add this line
                          onChange={licenceFormHandler}
                          onBlur={handleBlur}
                        />
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    ) : field.formValueLabel === "city" ? (
                      <>
                        <CitySuggestionInputField
                          name={field.formValueLabel}
                          type={field.type}
                          placeholder={""}
                          value={licenceInfo[field?.formValueLabel] || ""}
                          onChange={licenceFormHandler}
                          required={field.required}
                          className={`${
                            formErrors?.[field.formValueLabel]
                              ? "is-invalid"
                              : ""
                          } form-control pp-input-field pp-form-label form-field-style`}
                          suggestions={field.options}
                          onBlur={handleBlur}
                        />
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    ) : (
                      <>
                        <Form.Control
                          type={field.type}
                          // placeholder={field.placeholder}
                          className={`${
                            formErrors[field.formValueLabel]
                              ? "error-border"
                              : ""
                          } form-control pp-input-field pp-form-label form-field-style`}
                          // value={licenceInfo[field.formValueLabel]}
                          // onChange={licenceFormHandler}
                          value={licenceInfo[field?.formValueLabel]}
                          name={field.formValueLabel} // Add this line
                          onChange={licenceFormHandler}
                          onBlur={handleBlur}
                        />
                        {formErrors[field.formValueLabel] && (
                          <Form.Text className="text-danger">
                            {formErrors[field.formValueLabel]}
                          </Form.Text>
                        )}
                      </>
                    )}
                  </Form.Group>
                </>
              ))}
              <div className="bid-license-modal-btn-container">
                <Button
                  className="bid-license-modal-h-button-1"
                  variant="primary"
                  onClick={handleFormSubmit}
                >
                  {editData ? "Update" : "Add License"}
                </Button>
                <Button
                  className="bid-license-modal-h-button-2"
                  variant="secondary"
                  onClick={closeModal}
                >
                  Cancel
                </Button>
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LicenceModal;
